
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"19","viewBox":"0 0 25 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.8 0H2.2C1 0 0 1 0 2.2v14.6C0 18 1 19 2.2 19h20.6c1.2 0 2.2-1 2.2-2.2V2.2C25 1 24 0 22.8 0zm-.3 1.5l-10 9.9-10-9.9h20zm-21 15v-14l7.1 7-7.1 7zm1 1l7.1-7 2.5 2.4c.3.3.7.3 1 0l2.4-2.4 7 7h-20zm21-1l-7-7 7-7v14z"}})])
          )
        }
      }
    